import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ka from '../locales/ka.json' with { type: 'json' };
import en from '../locales/en.json' with { type: 'json' };

/**
 * i18n setup — Georgian (ka) primary, English (en) fallback.
 *
 * SPEC rule: all UI strings go through this. Never hardcode Georgian (or
 * English) text in feature files — call `t('auth.signup.title')` instead.
 *
 * Adding a string:
 *   1. Add the Georgian value to `locales/ka.json` under the right feature.
 *   2. Mirror the English in `locales/en.json`.
 *   3. Call `const { t } = useTranslation(); t('feature.nested.key')`.
 *
 * Language is fixed to `ka` for v1 — no in-app switcher. Falls back to `en`
 * only when a key is missing (dev safety net).
 */

void i18n.use(initReactI18next).init({
  resources: {
    ka: { translation: ka },
    en: { translation: en },
  },
  lng: 'ka',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes
  },
  returnNull: false,
});

export default i18n;
